(() => {
 const validateText = input => {
  const value=input.value.trim();
  let message='';
  if(input.required&&!value)message='Please fill in this field.';
  if(input.hasAttribute('data-towel-initials')&&!/^[A-Za-z]{2,3}$/.test(value))message='Please enter 2 or 3 letters in the order you want embroidered.';
  input.setCustomValidity(message);
 };
 document.addEventListener('input',event=>{
  if(event.target.matches('[data-towel-text],[data-towel-initials]'))validateText(event.target);
  const form=event.target.closest('[data-preview-towel]');
  if(form)document.querySelector('[data-towel-review]').hidden=true;
 });
 document.addEventListener('change',event=>{
  if(event.target.matches('[data-grip-color]')){
   const container=event.target.closest('form').querySelector('[data-other-grip]');
   const input=container.querySelector('input');
   const other=event.target.value==='Other';
   container.hidden=!other;input.disabled=!other;input.required=other;
   if(!other){input.value='';input.setCustomValidity('');}
  }
 });
 document.addEventListener('click',event=>{
  const button=event.target.closest('[data-photo]');if(!button)return;
  const photo=document.querySelector('#TowelPhoto');photo.src=button.dataset.photo;
  photo.alt=button.querySelector('img').alt;
  document.querySelectorAll('[data-photo]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
 });
 document.addEventListener('submit',event=>{
  const form=event.target;if(!form.matches('[data-towel-form]'))return;
  form.querySelectorAll('[data-towel-text],[data-towel-initials]').forEach(input=>{if(!input.disabled){input.value=input.value.trim();validateText(input);}});
  if(!form.checkValidity()){event.preventDefault();form.reportValidity();return;}
  if(!form.hasAttribute('data-preview-towel'))return;
  event.preventDefault();
  const data=new FormData(form);const review=document.querySelector('[data-towel-review]');
  review.replaceChildren();const heading=document.createElement('h2');heading.textContent='Your personalized towel';review.append(heading);
  for(const [name,value] of data){if(name==='quantity'||name==='properties[Personalization confirmed]')continue;const line=document.createElement('p');line.textContent=name.replace(/^properties\[/,'').replace(/\]$/,'')+': '+value;review.append(line);}
  const total=document.createElement('p');total.textContent=`Quantity: ${data.get('quantity')} · Item subtotal: $${(23.99*Number(data.get('quantity'))).toFixed(2)} USD`;review.append(total);
  const note=document.createElement('p');note.textContent='Preview only — nothing has been ordered or saved. Shipping and taxes are not included.';review.append(note);
  review.hidden=false;review.focus();
 });
})();
